export default {"src":"/_next/static/media/NI.b35fef2e.svg","height":18,"width":18};